export default "__VITE_ASSET__TEgfpRKN53ebRMJkwAsJDw__"